import React from 'react';

import { FormattedMessage } from '../../util/reactIntl';
import { isFieldForListingType } from '../../util/fieldHelpers';
import { renderCustomIcons } from '../../util/renderCustomIcons';
import { getCountryFlagByName } from '../../util/getCountryFlag';
import { languagesHelper as language } from '../../util/languages';

import { Heading } from '../../components';

import css from './ListingPage.module.css';

const SectionDetailsMaybe = props => {
  const { publicData, metadata = {}, listingFieldConfigs, isFieldForCategory, intl } = props;

  if (!publicData || !listingFieldConfigs) {
    return null;
  }

  const { categoryLevel1 } = publicData;

  const pickListingFields = (filteredConfigs, config) => {
    const { key, schemaType, enumOptions, showConfig = {} } = config;
    const listingType = publicData.listingType;
    const isTargetListingType = isFieldForListingType(listingType, config);
    const isTargetCategory = isFieldForCategory(config);

    const { isDetail, label } = showConfig;
    const publicDataValue = publicData[key];
    const metadataValue = metadata[key];
    const value = typeof publicDataValue != null ? publicDataValue : metadataValue;

    if (isDetail && isTargetListingType && isTargetCategory && typeof value !== 'undefined') {
      const findSelectedOption = enumValue => enumOptions?.find(o => enumValue === `${o.option}`);
      const getBooleanMessage = value =>
        value
          ? intl.formatMessage({ id: 'SearchPage.detailYes' })
          : intl.formatMessage({ id: 'SearchPage.detailNo' });
      const optionConfig = findSelectedOption(value);

      const getEnumIcon = (key, option) => {
        if (key === 'listingfield_staytype') {
          return renderCustomIcons[option] || null;
        } else {
          return renderCustomIcons[key] || null;
        }
      };

      return schemaType === 'enum'
        ? filteredConfigs.concat({
          key,
          value: optionConfig?.label,
          valueKey: optionConfig?.option,
          label,
          icon: getEnumIcon(key, optionConfig.option),
        })
        : schemaType === 'boolean'
          ? filteredConfigs.concat({
            key,
            value: getBooleanMessage(value),
            label,
            icon: renderCustomIcons[key] || null,
          })
          : schemaType === 'long'
            ? filteredConfigs.concat({ key, value, label, icon: renderCustomIcons[key] || null })
            : filteredConfigs;
    }
    return filteredConfigs;
  };

  const existingListingFieldsForColumns =
    categoryLevel1 === 'category-stay'
      ? listingFieldConfigs
        .filter(
          item => item.key !== 'linstingFieldId_country' && item.key !== 'listingfield_network'
        )
        .reduce(pickListingFields, [])
      : [];

  const existingListingFieldsForRows =
    categoryLevel1 === 'category-stay'
      ? listingFieldConfigs
        .filter(
          item => item.key === 'linstingFieldId_country' || item.key === 'listingfield_network'
        )
        .reduce(pickListingFields, [])
      : [];

  const existingListingFields =
    categoryLevel1 !== 'category-stay' ? listingFieldConfigs.reduce(pickListingFields, []) : [];

  return existingListingFieldsForColumns.length > 0 ||
    existingListingFieldsForRows.length > 0 ||
    existingListingFields.length > 0 ? (
    <section className={css.sectionDetails}>
      <Heading as="h2" rootClassName={css.sectionHeading}>
        <FormattedMessage id="ListingPage.detailsTitle" />
      </Heading>
      {existingListingFieldsForColumns.length > 0 && (
        <ul className={css.columnsWrapper}>
          {existingListingFieldsForColumns.map(detail => (
            <li key={detail.key} className={css.detailsColumn}>
              <span className={css.detailIcon}>{detail.icon}</span>
              <span className={css.detailTextColumn}>
                {/* {detail.label} */}
                {language.labelsTranslator(detail.key, intl)}
                </span>
              <span className={css.detailTextColumn}>
                {/* {detail.value} */}
                {isNaN(detail.value) ? language.labelsTranslator(detail.valueKey, intl) : detail.value}
                </span>
            </li>
          ))}
        </ul>
      )}
      {existingListingFieldsForRows.length > 0 && (
        <ul className={css.rowsWrapper}>
          {existingListingFieldsForRows.map(detail => (
            <li key={detail.key} className={css.detailsRow}>
              <span className={css.detailLabel}>
                {/* {detail.label} */}
                {language.labelsTranslator(`pub_${detail.key}`, intl)}
              </span>
              <span className={css.detailValueRow}>
                {detail.key === 'linstingFieldId_country' && (
                  <span className={css.flag}>{getCountryFlagByName(detail.value)}</span>
                )}
                {/* {detail.value} */}
                {isNaN(detail.value) ? language.labelsTranslator(detail.value, intl) : detail.value}
              </span>
            </li>
          ))}
        </ul>
      )}
      {existingListingFields.length > 0 && (
        <ul className={css.rowsWrapper}>
          {existingListingFields.map(detail => (
            <li key={detail.key} className={css.detailsRow}>
              <span className={css.detailLabel}>
                {/* {detail.label} */}
                {language.labelsTranslator(`pub_${detail.key}`, intl)}
              </span>
              <span className={css.detailValueRow}>
                {detail.key === 'linstingFieldId_country' && (
                  <span className={css.flag}>{getCountryFlagByName(detail.value)}</span>
                )}
                {/* {detail.value} */}
                {isNaN(detail.value) ? language.labelsTranslator(detail.value, intl) : detail.value}
              </span>
            </li>
          ))}
        </ul>
      )}
    </section>
  ) : null;
};

export default SectionDetailsMaybe;
